import React from 'react';
import { useIntl } from 'react-intl';
import Dialog from '@rio-cloud/rio-uikit/Dialog';

interface DeleteSessionDialogProps {
    isOpen: boolean;
    onConfirm: () => void;
    onCancel: () => void;
}

const DeleteSessionDialog = ({ isOpen, onConfirm, onCancel }: DeleteSessionDialogProps) => {
    const intl = useIntl();

    const content = (
        <div className="text-center">
            <div className="margin-50">
                <div className="text-size-h4 margin-bottom-10">
                    {intl.formatMessage({ id: 'intl-msg:chatbot.deleteDialog.title' })}
                </div>
                <div className="text-size-14 text-color-gray">
                    {intl.formatMessage({ id: 'intl-msg:chatbot.deleteDialog.body' })}
                </div>
            </div>
            <div className="pull-right btn-toolbar">
                <button
                    type="button"
                    className="btn btn-default"
                    onClick={onCancel}
                    data-testid="delete-session-cancel-btn"
                >
                    {intl.formatMessage({ id: 'intl-msg:chatbot.deleteDialog.cancel' })}
                </button>
                <button
                    type="button"
                    className="btn btn-primary"
                    onClick={onConfirm}
                    data-testid="delete-session-confirm-btn"
                >
                    {intl.formatMessage({ id: 'intl-msg:chatbot.deleteDialog.confirm' })}
                </button>
            </div>
        </div>
    );

    return (
        <Dialog
            show={isOpen}
            onClose={onCancel}
            useOverflow
            body={content}
        />
    );
};

export default DeleteSessionDialog;
